import React, { useEffect, useState } from "react";
import { FaPalette } from "react-icons/fa";
import { connect } from "react-redux";
import { convertColor } from "../../../../_utils/common";
import TLDRColorPicker from "../../../common/tldrColorPicker/TLDRColorPicker";
import { withTranslation } from "react-i18next";

const TLDRTextColor = (props) => {
  const { activeElement, brandKit, showHexCode, display, zIndex, t } = props;

  const [fill, setFill] = useState(activeElement.format?.fill);

  useEffect(() => {
    setFill(activeElement?.format?.fill);
  }, [activeElement.format]);

  function onColorChange(action, value) {
    const { canvasRef } = props;
    setFill(value);
    canvasRef.handler.textHandler.textColor(value);
  }

  return (
    <TLDRColorPicker
      action={"color"}
      title={t("fonts.text_color")}
      showIcon={true}
      icon={FaPalette}
      color={typeof fill === "object" ? "transparent" : fill}
      property={"color"}
      callback={onColorChange}
      display={display}
      colorCode={
        showHexCode && typeof fill !== "object"
          ? convertColor(fill, "hex")
          : null
      }
      showBrandkitPaletteColors={brandKit.brandkitPayload.length > 0}
      canvas={props.canvasRef.canvas}
      showColorInput={!!props.showHexCode}
    />
  );
};

const mapStateToProps = (state) => ({
  activeElement: state.editor.activeElement,
  brandKit: state.brandKit,
});

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(TLDRTextColor)
);
